import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ReactComponent as WarningImage } from '../../assets/warning.svg';

const DeleteConfirmationDialog = ({ open, onClose, onConfirm, type = 'KPI' }: any) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: "#FFFFFF",
          color: "#1e293b",
          width: "560px !important",
          maxWidth: "100%",
          borderRadius: "8px",
          overflow: "hidden",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)"
        },
      }}
    >
      {/* Header Section */}
      <DialogTitle
        sx={{
          bgcolor: 'primary.main',
          color: '#FFFFFF',
          px: 3,
          py: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography sx={{ fontSize: '18px', fontWeight: 600, color: '#FFFFFF' }}>
          Deleting {type}
        </Typography>
        <IconButton onClick={onClose} sx={{ color: "#FFFFFF", p: 0.5 }}>
          <CloseIcon sx={{ fontSize: '20px' }} />
        </IconButton>
      </DialogTitle>

      {/* Content Section */}
      <DialogContent sx={{ padding: "24px !important", backgroundColor: "#FFFFFF" }}>
        <Box display="flex" alignItems="center" gap={3}>
          <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <WarningImage style={{ width: 56, height: 52 }} />
          </Box>
          <Box textAlign="left">
            <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#1e293b', mb: 1, lineHeight: 1.3 }}>
              Are you sure to delete this {type}?
            </Typography>
            <Typography sx={{ fontSize: '14px', color: '#64748b', fontWeight: 400 }}>
              Once confirmed, the action can't be undone.
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      {/* Actions Section */}
      <DialogActions sx={{ justifyContent: "flex-end", padding: "16px 28px 24px 28px", gap: 2, backgroundColor: "#FFFFFF" }}>
        <Button
          onClick={onClose}
          sx={{
            color: "#009BD8",
            fontWeight: 700,
            fontSize: "14px",
            textTransform: "uppercase",
            padding: "8px 16px",
            "&:hover": {
              backgroundColor: "rgba(0, 155, 216, 0.08)"
            }
          }}
        >
          NO, I WANT IT!
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            backgroundColor: "#FF2D2D !important",
            color: "#FFFFFF !important",
            fontWeight: 700,
            fontSize: "14px",
            textTransform: "uppercase",
            borderRadius: "4px",
            padding: "8px 28px",
            minWidth: "110px",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#E02424 !important",
              boxShadow: "none"
            }
          }}
        >
          DELETE
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;